export default __webpack_public_path__ + "assets/images/6cef89e60c8c7fdf006394e9b75caffd.svg";